export default __webpack_public_path__ + "static/media/flow1.19e984fa.jpg";